import moment from 'moment'
import React from 'react'
import { Table } from 'reactstrap'

const InventoryTabPanel = ({
  TabPanel,
  value,
  postInventoryHeaderArr,
  HtmlTooltip,
  information,
  postInventoryDataList,
  styles,
  stateConvert,
  loader,
  Timmer,
  setCommentModal,
  setEditComment,
  EditIcon,
  accordionOpenIndex,
  UpArrowIcon,
  setAccordionFunction,
  DownArrowBlueIcon,
  TdCollapseSectionInner,
  accordionInsideOpenIndex,
  setAccordionInsideFunction,
  orderType,
  loaderVisible,
  needPageCount,
  Pagination,
  needPage,
  handleInventoryPageChange
}) => (
  <TabPanel value={value} index={1}>
    <Table responsive>
      <thead>
        <tr>
          {postInventoryHeaderArr.map((items, index) => (
            <>{index === 1 || index === 4 || index === 7 ? <th key={index} style={{ "white-space": "normal", "min-width": "112px", "max-width": "112px" }}>{items.title}</th> :
              index === 5 ? <th key={index}>{items.title}
                <HtmlTooltip
                  placement="right"
                  enterTouchDelay={0}
                  arrow
                  title={<><p><b>No Action:</b> This status applies when an offer has been received, but no action has been taken, and the requested date is in the past.</p>
                    <p><b>Active:</b> The "Active" status pertains to a post that is currently active on the marketplace. It includes scenarios where no offer have been received, as well as cases
                      where offer have been received, and the requested delivery/pickup dates are in the future. For offers, the determination should be based on the receipt of offers and the dates for requested delivery/pickup in the future.</p>

                    <p><b>Expired:</b> The "Expired" status is assigned when no offer have been received, and the post has reached its expiration date or when an offer has timed out.</p>
                    <p><b>Order Created :</b> If order is created on the post.</p></>}
                >
                  <img style={{ paddingLeft: "5px", position: "relative", top: "-1px", cursor: "pointer" }} src={information} alt="Iicon" />
                </HtmlTooltip>
              </th>
                : index === 6 ? <th key={index}>{items.title}
                  <HtmlTooltip
                    placement="right"
                    enterTouchDelay={0}
                    arrow
                    title={<><p><b>Pending:</b> When an offer has been received, this status indicates that a decision is pending. If an offer is accepted, it should appear in the dropdown menu, including relevant details such as the target price and other specifications outlined in the design.</p>
                      {/* <p><b>Timed Out:</b> In cases where an offer is received but the decision process takes too long, resulting in a timeout.</p> */}

                      <p><b>Offer Declined:</b> When an offer has been received but is subsequently declined.</p>
                      <p><b>Accepted:</b> Upon receiving an offer, if it is accepted, an order is created successfully.</p></>}
                  >
                    <img style={{ paddingLeft: "5px", position: "relative", top: "-1px", cursor: "pointer" }} src={information} alt="Iicon" />
                  </HtmlTooltip>
                </th>
                  : <th key={index}>{items.title}</th>}</>
          ))}
        </tr>
      </thead>
      <tbody className='post-tab-table-tbody'>
        {
          postInventoryDataList && postInventoryDataList?.length !== 0 ? postInventoryDataList.map((items, index) => (
            <>
              <tr className={styles.homeWrapper} key={index}>
                <td title={items?.postName}>
                  {items?.postName?.substring(0, 10)}
                  {items?.postName?.length > 10 && <span>...</span>}
                </td>
                <td>{items?.postDetails?.private ? 'Yes' : 'No'}</td>
                <td>{items?.posterDetails?.email}</td>
                {/* <td>{items?.posterDetails?.companyName} - {items?.posterDetails?.address?.city + ", " + stateConvert(items?.posterDetails?.address?.state)}</td> */}
                <td>{items?.postDetails?.shippingAddress?.locationName} - {items?.postDetails?.shippingAddress?.city + ", " + (items?.postDetails?.shippingAddress?.stateAbv ? items?.postDetails?.shippingAddress?.stateAbv : stateConvert(items?.postDetails?.shippingAddress?.state))}</td>
                <td>{items?.noOfBidsAndOffers}</td>
                <td>{items?.postStatus}</td>
                <td>{items?.postBidOrOfferStatus}</td>

                <td style={loader ? { display: 'none' } : { display: 'block' }}>
                  {items?.postStatus === "ACTIVE" ? <Timmer time={items?.postTimeLeft - Math.trunc(Date.now() / 1000)} /> : "00:00:00"}
                </td>
                <td style={loader ? { display: 'block' } : { display: 'none' }}></td>
                <td style={{ "cursor": "pointer" }} title={items?.accountRepresentative && items?.accountRepresentative.length !== 0 ? items?.accountRepresentative.join(', ') : ''}>
                  {items?.accountRepresentative && items?.accountRepresentative.length !== 0 ? items?.accountRepresentative.join(', ').substring(0, 15) : "NA"}
                  {items?.accountRepresentative && items?.accountRepresentative.length !== 0 ? items?.accountRepresentative.join(', ')?.length > 15 && <span>...</span> : ""}
                </td>
                <td title={items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg}>
                  <span style={{ marginRight: "8px" }} onClick={() => {
                    setCommentModal(true)
                    setEditComment(items)
                  }}><EditIcon /></span>
                  {items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg?.substring(0, 3)}
                  {items?.adminComments?.postCommentByAdmin && items?.adminComments?.postCommentByAdmin[0]?.msg?.length > 3 && <span>...</span>}
                </td>
                <td className='expand-collapse-class'>
                  <div>
                    {(accordionOpenIndex === index) ?
                      <UpArrowIcon onClick={() => setAccordionFunction()} />
                      :
                      <DownArrowBlueIcon onClick={() => setAccordionFunction(index)} />
                    }
                  </div>
                </td>
              </tr>

              {accordionOpenIndex === index &&
                <>{items?.postStatus !== "ORDER CREATED" ? items?.postBidOrOfferInfo && items?.postBidOrOfferInfo.map((bidItems, bidIndex) => (
                  <>
                    <tr className='order-details-wrapper'>
                      <td colspan="1">
                        <div>
                          <p></p>
                        </div>
                      </td>
                      <td colspan="1"> </td>
                      <td colspan="1">
                        <div>
                          <p>{bidItems?.bidderEmail}</p>
                        </div>
                      </td>
                      <td colspan="1">
                        <div>
                          <p>{bidItems?.bidderCompanyName}</p>
                        </div>
                      </td>
                      <td colspan="1">
                        <div>
                          <p>{bidItems?.bidderPhoneNumber ? bidItems?.bidderPhoneNumber : "NA"}</p>
                        </div>
                      </td>
                      <td colspan="1">
                        <div>
                          <p>{moment(bidItems?.bidDate.split('T')[0]).format("MM/DD/YYYY")}</p>
                        </div>
                      </td>
                      <td colspan="1">
                        <div>
                          <p>{bidItems?.bidStatus}</p>
                        </div>
                      </td>
                      <td colspan="1">
                        {items?.postStatus === "ACTIVE" && (bidItems?.bidStatus === "Buynow-DEL Received" || bidItems?.bidStatus === "Buynow-PU Received") ? <Timmer time={bidItems?.pendingResponseTimeOut - Math.trunc(Date.now() / 1000)} /> : ""}
                      </td>
                      {/* <td colspan="1"></td> */}
                      <td colspan="1" style={{ "cursor": "pointer" }} title={bidItems?.bidderAccountRepresentative && bidItems?.bidderAccountRepresentative.length !== 0 ? bidItems?.bidderAccountRepresentative.join(', ') : ''}>
                        {bidItems?.bidderAccountRepresentative && bidItems?.bidderAccountRepresentative.length !== 0 ? bidItems?.bidderAccountRepresentative.join(', ').substring(0, 15) : "NA"}
                        {bidItems?.bidderAccountRepresentative && bidItems?.bidderAccountRepresentative.length !== 0 ? bidItems?.bidderAccountRepresentative.join(', ')?.length > 15 && <span>...</span> : ""}
                      </td>
                      <td title={bidItems?.bidComment && bidItems?.bidComment}>
                        {bidItems?.bidComment && bidItems?.bidComment?.substring(0, 15)}
                        {bidItems?.bidComment && bidItems?.bidComment?.length > 15 && <span>...</span>}
                      </td>
                      <td colspan="1">
                      </td>
                      <td colspan="1"></td>
                    </tr>

                    {accordionInsideOpenIndex === bidIndex &&
                      <>
                        <tr className='order-details-wrapper' style={{ background: "#ECECEC" }}>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                          <td colspan="3" />

                          <td colspan="1"></td>
                          <td colspan="1"></td>
                          <td colspan="1"> </td>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                          <td colspan="1"></td>
                        </tr>
                      </>
                    }
                  </>
                )) : <>
                  <tr className='order-details-wrapper'>
                    <td colspan="1">
                      <div>
                        <p></p>
                      </div>
                    </td>
                    <td colspan="1"> </td>
                    <td colspan="1">
                      <div>
                        <p>{items?.postBidOrOfferInfo[0]?.bidderEmail}</p>
                      </div>
                    </td>
                    <td colspan="1">
                      {items?.postBidOrOfferInfo[0]?.bidStatus === "Buynow-DEL Accepted" ||
                        items?.postBidOrOfferInfo[0]?.bidStatus === "Buynow-PU Accepted" ||
                        items?.postBidOrOfferInfo[0]?.bidStatus === "Offer Accepted" ||
                        items?.postBidOrOfferInfo[0]?.bidStatus === "Alt Offer Accepted" ? <TdCollapseSectionInner>
                        <p>{items?.postBidOrOfferInfo[0]?.bidderCompanyName}</p>
                        <div className='expand-collapse-class-inside'>
                          {(accordionInsideOpenIndex === 0) ?
                            <h4 onClick={() => setAccordionInsideFunction()}><i></i></h4>
                            :
                            <h5 onClick={() => setAccordionInsideFunction(0)}><i></i></h5>
                          }
                        </div>
                      </TdCollapseSectionInner> : <p>{items?.postBidOrOfferInfo[0]?.bidderCompanyName}</p>}
                    </td>
                    <td colspan="1">
                      <div>
                        <p>{items?.postBidOrOfferInfo[0]?.bidderPhoneNumber ? items?.postBidOrOfferInfo[0]?.bidderPhoneNumber : "NA"}</p>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <p>{moment(items?.postBidOrOfferInfo[0]?.bidDate.split('T')[0]).format("MM/DD/YYYY")}</p>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <p>{items?.postBidOrOfferInfo[0]?.bidStatus}</p>
                      </div>
                    </td>
                    <td colspan="1">
                      {items?.postStatus === "EXPIRED" || items?.postStatus === "ORDER CREATED" ? "" : <Timmer time={items?.postBidOrOfferInfo[0]?.pendingResponseTimeOut - Math.trunc(Date.now() / 1000)} />}
                    </td>
                    <td colspan="1" style={{ "cursor": "pointer" }} title={items?.postBidOrOfferInfo?.bidderAccountRepresentative && items?.postBidOrOfferInfo?.bidderAccountRepresentative.length !== 0 ? items?.postBidOrOfferInfo?.bidderAccountRepresentative.join(', ') : ''}>
                      {items?.postBidOrOfferInfo?.bidderAccountRepresentative && items?.postBidOrOfferInfo?.bidderAccountRepresentative.length !== 0 ? items?.postBidOrOfferInfo?.bidderAccountRepresentative.join(', ').substring(0, 15) : "NA"}
                      {items?.postBidOrOfferInfo?.bidderAccountRepresentative && items?.postBidOrOfferInfo?.bidderAccountRepresentative.length !== 0 ? items?.postBidOrOfferInfo?.bidderAccountRepresentative.join(', ')?.length > 15 && <span>...</span> : ""}
                    </td>
                    <td title={items?.postBidOrOfferInfo[0]?.bidComment && items?.postBidOrOfferInfo[0]?.bidComment}>
                      {items?.postBidOrOfferInfo[0]?.bidComment && items?.postBidOrOfferInfo[0]?.bidComment?.substring(0, 15)}
                      {items?.postBidOrOfferInfo[0]?.bidComment && items?.postBidOrOfferInfo[0]?.bidComment?.length > 15 && <span>...</span>}
                    </td>
                    <td colspan="1"> </td>
                    <td colspan="1"></td>
                  </tr>

                  {accordionInsideOpenIndex === 0 &&
                    <>
                      <tr className='order-details-wrapper' style={{ background: "#ECECEC" }}>
                        <td colspan="1"></td>
                        <td colspan="1"></td>
                        <td colspan="1"></td>
                        <td colspan="2">
                          <div style={{ maxWidth: "300px" }}>
                            <p>{orderType(items?.postDetails, items?.postBidOrOfferInfo[0]?.quantity)} - {items?.postBidOrOfferInfo[0]?.bidStatus} @ ${items?.postBidOrOfferInfo[0]?.bidPrice} for {items?.postBidOrOfferInfo[0]?.pickup ? "Pickup from" : "Delivery to"} {items?.postBidOrOfferInfo[0]?.shippingAddress?.locationName}, {items?.postBidOrOfferInfo[0]?.shippingAddress?.address1}, {items?.postBidOrOfferInfo[0]?.shippingAddress?.address2 ? items.postBidOrOfferInfo[0].shippingAddress.address2 + "," : ""} {items?.postBidOrOfferInfo[0]?.shippingAddress?.city} {items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv ? items?.postBidOrOfferInfo[0]?.shippingAddress?.stateAbv : stateConvert(items?.postBidOrOfferInfo[0]?.shippingAddress?.state)}{(items?.postBidOrOfferInfo[0]?.shippingAddress?.zipCode) ? ", " + items.postBidOrOfferInfo[0].shippingAddress.zipCode : ""} on {moment(items?.postBidOrOfferInfo[0]?.bidDate.split('T')[0]).format("MM/DD/YYYY")}</p>
                          </div>
                        </td>
                        <td colspan="1"></td>
                        <td colspan="1"></td>
                        <td colspan="1"></td>
                        <td colspan="1"> </td>
                        <td colspan="1"></td>
                        <td colspan="1"></td>
                        <td colspan="1"></td>
                      </tr>
                    </>
                  }
                </>}</>
              }

            </>
          )) :

            <>{!loaderVisible && !loader ? <tr className={styles.homeWrapper}>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td><p>No Record found</p></td>
            </tr> :
              <tr className={styles.homeWrapper}></tr>}
            </>
        }
      </tbody>
    </Table>
    {needPageCount !== 0 && postInventoryDataList && postInventoryDataList?.length !== 0 ? <Pagination count={needPageCount}
      page={needPage}
      onChange={handleInventoryPageChange} /> : ""}
  </TabPanel>
)


export default InventoryTabPanel